import { Button } from "primereact/button";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import HeadingNavigation from "../../Navigation/TopNavigation/HeadingNavigation";
import banner from "../../images/banner image/AllCarsBanner.png";
import { ProgressSpinner } from "primereact/progressspinner";

function AllProductCars() {
  const [productsDara, setProductsDara] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/allCars")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch productsDara");
        }
        return res.json();
      })
      .then((data) => {
        setProductsDara(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching productsDara:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <ProgressSpinner />
        Loading...
      </div>
    );
  }

  return (
    <>
      <HeadingNavigation />
      {/* Banner Image */}
      <div className="m-2">
        <img
          src={banner}
          alt="Banner"
          className="w-full  object-cover"
          style={{ maxHeight: "300px" }}
        />
      </div>
      <Divider />
      <div className="flex flex-wrap justify-content-center gap-3 p-3 surface-100">
        {productsDara.map((item) => (
          <Card
            key={item.id}
            className="w-full sm:w-20rem md:w-18rem text-center shadow-6"
            style={{ borderRadius: "30px" }}>
            <img
              alt={item.productName}
              src={`data:image/png;base64,${item.previewImg}`}
              className="w-full border-round-md mt-2"
              style={{ height: "12rem", width: "auto" }}
            />
            <span className="mt-3 text-base font-bold text-gray-800 block white-space-nowrap overflow-hidden text-overflow-ellipsis">
              {item.productName}
            </span>
            <span>{`${item.ageGroup} Years`}</span>

            <p className="text-red-500 font-bold text-lg">₹{item.price}</p>
            <div className="flex justify-content-center">
              <Button
                onClick={() => {
                  navigate(`/carsById/${item.productID}`, {
                    state: { product: item },
                  });
                  sessionStorage.setItem("productId", item.productID);
                }}
                size="small"
                severity="info"
                rounded
                className="mt-2">
                View Product
              </Button>
            </div>
          </Card>
        ))}
      </div>
      <br />
    </>
  );
}

export default AllProductCars;
